import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
//
import { Card } from "react-bootstrap";
//
import BoxLoading from "../general/BoxLoading.jsx";
import DesktopTopWinners from "./top-winners/DesktopTopWinners";
import MobileTopWinners from "./top-winners/MobileTopWinners";
import FilterDropdown from "../general/FilterDropdown";
import NothingToShow from "../general/NothingToShow";

function TopTenWinners({
  windowSize,
  items,
  loading,
  activeFilter,
  setActiveFilter,
  activeTimeFilter
}) {
  let filters = [
    {
      name: "All Status",
      value: "all",
    },
    {
      name: "Buy",
      value: "buy",
    },
    {
      name: "Sell",
      value: "sell",
    },
  ];
  return (
    <Card className="top-winners">
      <Card.Header className="with-dropdown">
        Top 10 Earners of the {activeTimeFilter}
        <FilterDropdown
          filters={filters}
          activeFilter={activeFilter}
          action={(item) => setActiveFilter(item)}
        />
      </Card.Header>

      <Card.Body className={windowSize > 576 ? "table-padding" : "p-0"}>
        {items.length ? (
          <>
          {windowSize > 576 ? (
          <DesktopTopWinners items={items} />
        ) : (
          <MobileTopWinners items={items} />
        )}
          </>
        ) : (
          <NothingToShow text={loading ? "Loading..." : "Nothing to show"} />
        )}
      </Card.Body>

      {loading && <BoxLoading />}
    </Card>
  );
}

TopTenWinners.propTypes = {
  windowSize: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  windowSize: state.themeReducer.windowSize,
});

export default connect(mapStateToProps)(TopTenWinners);
